<template>
  <div>
    <v-container fluid>
      <v-dialog
        v-model="unknownTermsDialog"
        max-width="800px"
        content-class="white card-curvey no-paddings"
      >
        <div class="white card-curvey no-paddings">
          <unknown-words style="padding-top: 0">
            <v-layout slot="title">
              <span class="unknown-terms-title">Unknown Terms</span>
              <v-spacer />
              <v-btn flat @click="unknownTermsDialog = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-layout>
          </unknown-words>
        </div>
      </v-dialog>
      <v-layout>
        <h1 class="display-1 font-weight-bold">NLP</h1>
        <v-spacer></v-spacer>
        <v-btn large round color="primary" @click="unknownTermsDialog = true"
          ><v-icon>list</v-icon> Check Unknown Terms</v-btn
        >
        <v-btn large round color="primary" @click="addRule"
          ><v-icon>add</v-icon> Add AI Rule</v-btn
        >
      </v-layout>
      <transition-group name="list" tag="div">
        <div
          class="card-curvey rule list-item"
          v-if="rules.length"
          v-for="(rule, index) in rules"
          :key="index"
        >
          <rule :rule="rule" :blocks="blocks" type="intents"></rule>
          <v-btn
            @click="deleteRule(rule)"
            class="delete-rule"
            fab
            small
            color="#666"
            ><v-icon color="white">delete_outline</v-icon></v-btn
          >
        </div>
      </transition-group>
    </v-container>
  </div>
</template>

<script>
import _ from "lodash";
import common from "../../utils/common";
import rule from "../ai/nlpRules";
import unknownWords from "../insights/unknown-words";
export default {
  components: {
    rule,
    unknownWords,
  },
  data() {
    return {
      rules: [],
      blocks: [],
      unknownTermsDialog: false,
    };
  },
  mounted() {
    this.getBotAIs();
    this.getBlocks();
  },
  methods: {
    getBotAIs() {
      this.$store.dispatch("setLoader", true);
      this.$http_bot
        .get(`/intents`)
        .then((response) => {
          this.rules = response.data;
          this.$store.dispatch("setLoader", false);
        })
        .catch((error) => {
          this.$store.dispatch("setLoader", false);
          if (error.response && error.response.status === 401) {
            common.logOut();
          } else {
            this.$store.dispatch("setErrorMessage", true);
          }
        });
    },
    getBlocks() {
      this.$store.dispatch("setLoader", true);
      this.$http_bot
        .get("/blocks")
        .then((response) => {
          this.blocks = response.data;
          this.$store.dispatch("setLoader", false);
        })
        .catch((error) => {
          this.$store.dispatch("setLoader", false);
          if (error.response && error.response.status === 401) {
            common.logOut();
          } else {
            this.$store.dispatch("setErrorMessage", true);
          }
        });
    },
    addRule() {
      this.$store.dispatch("setLoader", true);
      this.$store.dispatch("setSavingStatus", true);
      const rule = {
        bot_id: this.botId,
        replay: [{ type: "text", text: "", blocks: [], errorOrEmpty: 0 }],
        terms: [],
      };
      this.$http
        .post("/intents", rule)
        .then((response) => {
          let ai = response.data;
          ai.terms = [];
          this.rules.unshift(ai);
          this.$store.dispatch("setSavingStatus", false);
          this.$store.dispatch("setLoader", false);
        })
        .catch((error) => {
          this.$store.dispatch("setLoader", false);
          if (error.response && error.response.status === 401) {
            common.logOut();
          } else {
            this.$store.dispatch("setErrorMessage", true);
          }
        });
    },
    deleteRule(rule) {
      this.$store.dispatch("setLoader", true);
      this.$http
        .delete(`/intents/${rule.id}`)
        .then((response) => {
          let index = _.findIndex(this.rules, (o) => {
            return o.id === rule.id;
          });
          this.rules.splice(index, 1);
          this.$store.dispatch("setLoader", false);
        })
        .catch((error) => {
          this.$store.dispatch("setLoader", false);
          if (error.response && error.response.status === 401) {
            common.logOut();
          } else {
            this.$store.dispatch("setErrorMessage", true);
          }
        });
    },
  },
  computed: {
    botId() {
      return this.$store.state.bot.botId;
    },
  },
};
</script>

<style>
.list-item-enter-active,
.list-item-leave-active {
  transition: opacity 0.3s, -webkit-transform 0.3s;
  transition: opacity 0.3s, transform 0.3s;
  transition: opacity 0.3s, transform 0.3s, -webkit-transform 0.3s;
  -webkit-transform-origin: left center;
  transform-origin: left center;
}
.list-item-enter,
.list-item-leave-to {
  opacity: 0;
  -webkit-transform: scale(0.5);
  transform: scale(0.5);
}
.list-item-leave-active {
  position: absolute;
}
.list-item-move {
  transition: -webkit-transform 0.4s linear 0.3;
  transition: transform 0.4s linear 0.3;
  transition: transform 0.4s linear 0.3, -webkit-transform 0.4s linear 0.3;
}
.no-paddings {
  padding: 0 0 0 0;
}
.unknown-terms-title {
  font-weight: bold;
  font-size: 120%;
  line-height: 3;
}
</style>
